export const PHONE_COUNTRIES = [
  { code: '+254', label: 'Kenya (+254)', localDigits: 9, placeholder: '712 345 678' },
  { code: '+256', label: 'Uganda (+256)', localDigits: 9, placeholder: '712 345 678' },
  { code: '+1', label: 'USA (+1)', localDigits: 10, placeholder: '555 123 4567' },
];

export const PLEDGE_CURRENCIES = [
  { code: 'KES', label: 'KES — Kenya Shilling' },
  { code: 'UGX', label: 'UGX — Uganda Shilling' },
  { code: 'USD', label: 'USD — US Dollar ($)' },
];

/** @returns {string} E.164-style phone e.g. +254712345678 */
export function buildFullPhone(countryCode, localNumber) {
  const digits = String(localNumber ?? '').replace(/\D/g, '');
  return `${countryCode}${digits}`;
}

/** @returns {{ valid: boolean, message?: string, full?: string }} */
export function validatePledgePhone(countryCode, localNumber) {
  const country = PHONE_COUNTRIES.find((c) => c.code === countryCode);
  if (!country) {
    return { valid: false, message: 'Please select a country code.' };
  }

  const digits = String(localNumber ?? '').replace(/\D/g, '');
  if (!digits) {
    return { valid: false, message: 'Phone number is required.' };
  }

  if (digits.length !== country.localDigits) {
    return {
      valid: false,
      message: `Enter ${country.localDigits} digits for ${country.label}.`,
    };
  }

  const full = buildFullPhone(countryCode, digits);
  return { valid: true, full };
}
